module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0125.jpg?v=ea32bfd6";